"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = searchText;
var _ykbUtils = require("ykb-utils");
function searchText(target, search) {
  if (!search) {
    return true;
  }
  if ((0, _ykbUtils.isNullOrUndefined)(target)) {
    return false;
  }
  var strTarget = target.toString();
  if (!strTarget) {
    return false;
  }
  return strTarget.toLocaleLowerCase('tr').includes(search.toLocaleLowerCase('tr'));
}